export enum LearnosityPlayerEvent {
  TEST_SUBMITTED = 'TEST_SUBMITTED',
}
